// extracted by mini-css-extract-plugin
export var hidden = "_ns-1";
export var visible = "_ns-0";